<template>
  <ComboPicker
    :label="orientation == 'horizontal' ? null : label"
    strings="tipo"
    icon="mdi-tune"
    :bothIcons="orientation == 'horizontal'"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todos os tipos' : '(Todos)'"
    types="grouped-items"
    :tags="[]"
    :items="allInfos"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { allInfos } from './Informations'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Tipo de Mailbox' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  data() {
    return {
      allInfos
    }
  }
}
</script>

<style></style>
